import { ReactComponent as PickupIcon } from 'assets/icons/pickup.svg';
import { ReactComponent as DropoffIcon } from 'assets/icons/dropoff.svg';
import { PICKUP, DROPOFF } from 'utils/itineraries';

const stopTypeIcons = {
  [PICKUP]: ({ props }) => <PickupIcon {...props} />,
  [DROPOFF]: ({ props }) => <DropoffIcon {...props} />,
};

const StopIcon = ({ stopType, ...props }) => {
  if (stopType !== PICKUP && stopType !== DROPOFF) {
    return null;
  }

  const Component = stopTypeIcons[stopType];

  return <Component {...props} />;
};

export default StopIcon;
